// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseActivityFilter_activity_filter_row__Y3slF {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  margin: 8px 15px 16px;
}

.CaseActivityFilter_activity_filter_label__ZVKPs {
  font-size: 14px;
  color: var(--color-font-10);
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/CaseActivityFilter/CaseActivityFilter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB","sourcesContent":[".activity_filter_row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 16px;\n  margin: 8px 15px 16px;\n}\n\n.activity_filter_label {\n  font-size: 14px;\n  color: var(--color-font-10);\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activity_filter_row": `CaseActivityFilter_activity_filter_row__Y3slF`,
	"activity_filter_label": `CaseActivityFilter_activity_filter_label__ZVKPs`
};
export default ___CSS_LOADER_EXPORT___;
